import { FC } from "react";
import { makeStyles } from "tss-react/mui";
import {
  MiInputSelectBox,
  MiSkeleton,
  SKELETON_VARIANTS,
} from "@miplatform/components";
import { Box, Typography } from "@mui/material";

export const FilterSidebarSelectBox: FC<FilterSelectBoxProps> = ({
  label,
  options,
  value,
  onChange,
  loading,
}) => {
  const { classes } = useStyles();
  return (
    <Box>
      <Typography className={classes.label}>{label}</Typography>
      {loading ? (
        <MiSkeleton
          variant={SKELETON_VARIANTS.RECTANGULAR}
          height={40}
          className={classes.loadingInput}
        />
      ) : (
        <MiInputSelectBox
          options={options}
          value={value}
          handleChange={onChange}
          className={classes.filterInput}
          disableNone
        />
      )}
    </Box>
  );
};

interface FilterSelectBoxProps {
  label: string;
  options: { label: string; value: string | number | undefined }[];
  value: string | number | undefined;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  loading?: boolean;
}

const useStyles = makeStyles()((theme) => ({
  label: {
    fontSize: theme.fontSize.small,
    fontWeight: 600,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  filterInput: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(1),
  },
  loadingInput: {
    borderRadius: theme.spacing(1),
  },
}));
